import { render, staticRenderFns } from "./CustomTable最新.vue?vue&type=template&id=53b5229e&scoped=true"
import script from "./CustomTable最新.vue?vue&type=script&lang=js"
export * from "./CustomTable最新.vue?vue&type=script&lang=js"
import style0 from "./CustomTable最新.vue?vue&type=style&index=0&id=53b5229e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b5229e",
  null
  
)

export default component.exports